import React, { useEffect, useState, useRef } from 'react';
import { useSearchParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import './custom-tab.scss';
import Tab from './tab';
import { LeftArrowIcon, RightArrowIcon } from '../icons/icons';
import NewButton from '../button/newButton';

function Tabs({ className, disableURL, slideSize, bodyClass, ...props }) {
  const [activeTab, setActiveTab] = useState();
  const tabRef = useRef();
  const tabHeader = useRef();
  const tabMenu = useRef();
  const [searchParams, setSearchParams] = useSearchParams();
  const [tabHeaderWidth, setTabHeaderWidth] = useState(0);
  const [tabMenuWidth, setTabMenuWidth] = useState(0);

  useEffect(() => {
    if (props?.children && props.children.length > 0 && !activeTab) {
      setActiveTab(props.children[0].props?.value);
    }
  }, [props.children, activeTab]);

  const onClickTabItem = (tab) => {
    setActiveTab(tab);
    if (!disableURL) {
      if (tab === 'Documents') {
        searchParams.set('filterBy', 'all');
        searchParams.delete('markId');
      } else if (tab !== 'Locations') {
        searchParams.forEach((value, key) => {
          searchParams.delete(key);
        });
      }
      searchParams.set('activeTab', tab);
      setSearchParams(searchParams);
    }
  };

  useEffect(() => {
    if (!disableURL) {
      if (
        searchParams.get('activeTab') &&
        searchParams.get('activeTab') !== activeTab
      ) {
        setActiveTab(searchParams.get('activeTab'));
        onClickTabItem(searchParams.get('activeTab'));
      }
    }
  }, [activeTab, searchParams.get('activeTab')]);

  useEffect(() => {
    if (props?.allDetailsButtonClick > 0) {
      setActiveTab('About');
    }
  }, [props?.allDetailsButtonClick]);

  useEffect(() => {
    setTabHeaderWidth(tabHeader?.current?.getBoundingClientRect().width);
    setTabMenuWidth(tabMenu?.current?.getBoundingClientRect().width);
  }, [tabHeader]);

  const handleTabLeftMenuScroll = () => {
    if (tabHeader.current) {
      const currentScrollLeft = tabHeader.current.scrollLeft;
      tabHeader.current.scrollTo({
        left: currentScrollLeft - slideSize,
        behavior: 'smooth', // Smooth scrolling behavior
      });
    }
  };
  const handleTabRightMenuScroll = () => {
    if (tabHeader.current) {
      const currentScrollLeft = tabHeader.current.scrollLeft;
      tabHeader.current.scrollTo({
        left: currentScrollLeft + slideSize,
        behavior: 'smooth', // Smooth scrolling behavior
      });
    }
  };
  return (
    <div className={`custom-tabs ${className}`}>
      <div className="custom-tab-header d-flex align-center" ref={tabHeader}>
        {tabMenuWidth > tabHeaderWidth && (
          <NewButton className="arrow-left" onClick={handleTabLeftMenuScroll}>
            <LeftArrowIcon />
          </NewButton>
        )}
        <ul
          data-cy="tab-list"
          className="custom-tab-list"
          ref={tabMenu}
          // style={{ position: 'relative', left: scrollValue }}
        >
          {React.Children.map(props.children, (child) => {
            if (!child?.props) return null;

            const { label, icon, notification, completed, value } = child.props;

            return (
              <Tab
                ref={tabRef}
                activeTab={activeTab}
                key={label}
                label={label}
                onClick={onClickTabItem}
                icon={icon}
                notification={notification}
                completed={completed}
                value={value}
              />
            );
          })}
        </ul>
        {tabMenuWidth > tabHeaderWidth && (
          <NewButton className="arrow-right" onClick={handleTabRightMenuScroll}>
            <RightArrowIcon />
          </NewButton>
        )}
      </div>

      <div className={`custom-tab-content ${bodyClass}`}>
        {React.Children.map(props?.children, (child) => {
          if (!child?.props || child.props.value !== activeTab) {
            return null;
          }
          return child.props.children;
        })}
      </div>
    </div>
  );
}
Tabs.propTypes = {
  children: PropTypes.node.isRequired,
  allDetailsButtonClick: PropTypes.arrayOf(Object),
  className: PropTypes.string,
  disableURL: PropTypes.bool,
  slideSize: PropTypes.number,
  bodyClass: PropTypes.string,
};
Tabs.defaultProps = {
  allDetailsButtonClick: [],
  className: '',
  disableURL: false,
  slideSize: 100,
  bodyClass: '',
};
export default Tabs;
